import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Input } from 'shared/UI/Input'
import { Button, BUTTON_SIZES, BUTTON_TYPES } from 'shared/UI/Button'
import Validator from 'validatorjs'
import debounce from 'lodash/debounce'
import { useTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS } from 'shared/customHooks'
import isEmpty from 'lodash/isEmpty'

import './style.css.scss'

const RESEND_BTN_TEXT_DEBOUNCE_TIME = 2000

const InputEmailVerificationCode = (props) => {
  const { getTranslation } = useTranslation(TRANSLATION_KEYS.twoFAPage, props.locale)
  const initialSendBtnText = getTranslation(TRANSLATION_VALUE_KEYS.sendCode)
  const requiredCodeError = getTranslation(TRANSLATION_VALUE_KEYS.requiredSingleField, {
    fieldName: getTranslation(TRANSLATION_VALUE_KEYS.code)
  })

  const [verificationCode, setVerificationCode] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [resendBtnText, setResendBtnText] = useState(initialSendBtnText)

  const resetResendBtnTextCallback = useCallback(
    debounce(() => { setResendBtnText(initialSendBtnText) }, RESEND_BTN_TEXT_DEBOUNCE_TIME),
    []
  )

  const codeValidationRules = {
    code: 'required'
  }

  const handleCodeConfirm = () => {
    const validation = new Validator({ code: verificationCode }, codeValidationRules)
    if (validation.fails()) {
      setErrorMessage(requiredCodeError)
    } else {
      setErrorMessage('')
      props.onCodeConfirm(verificationCode)
    }
  }

  const handleResendCode = () => {
    props.onResendCode().then(() => {
      resendBtnText === initialSendBtnText &&
        setResendBtnText(getTranslation(TRANSLATION_VALUE_KEYS.codeSent))
      resetResendBtnTextCallback()
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    handleCodeConfirm()
  }

  const errorMessageToShow = errorMessage || props.errorMessage

  const colorStyle = (color)=>{
    return isEmpty(color) ? null : { color: color }
  }

  const { title, subtitle } = props.pageProperties

  return (
    <div className="by-email-auth-input input-verification-code">
      <p style={{...colorStyle(title.color)}} className="title">{ isEmpty(title.text) ? getTranslation(TRANSLATION_VALUE_KEYS.twoFAPageTitle) : title.text}</p>
       <div  className="info-text">{}</div>
      <form
        className="content"
        onSubmit={handleSubmit}>
        <p className="instructions">{getTranslation(TRANSLATION_VALUE_KEYS.enterConfirmationCode)}</p>
        <Input
          placeholder={getTranslation(TRANSLATION_VALUE_KEYS.typeCode)}
          onChange={e => setVerificationCode(e.target.value)}
          autoFocus={true}
          value={verificationCode}
          withErrorMessage={true}
          errorMessage={errorMessageToShow} />
        <Button
          className="submit-verification-code"
          onClick={handleCodeConfirm}
          size={BUTTON_SIZES.medium}>
          {getTranslation(TRANSLATION_VALUE_KEYS.continueToPage)}
        </Button>

        <Button
          className="resend-verification-code"
          onClick={handleResendCode}
          size={BUTTON_SIZES.medium}
          type={BUTTON_TYPES.secondaryText}>
          {resendBtnText}
        </Button>
        <div className="info">
          <span className="icon-info"></span>
          <p className="info-text">
            {getTranslation(TRANSLATION_VALUE_KEYS.codeSentConfirm)}
            <span className="info-email"> {`${props.emailSender}.`} </span>
            {` ${getTranslation(TRANSLATION_VALUE_KEYS.codeSentConfirmNote)}`}</p>
        </div>
      </form>
    </div>
  )
}

InputEmailVerificationCode.propTypes = {
  onCodeConfirm: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  onResendCode: PropTypes.func.isRequired,
  emailSender: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  pageProperties: PropTypes.object.isRequired
}

InputEmailVerificationCode.defaultProps = {
  errorMessage: ''
}

export default InputEmailVerificationCode
